import i18n from '@/utils/i18n';
import { PadBusinessType } from '@/hooks/payments/use-pad-payment-form-reducer';
import { RadioButton } from '@/components/radio-button';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

interface Props {
  onChange: (type: PadBusinessType) => void;
  padBusinessType: PadBusinessType | null;
}

export const PadBusinessTypeSelector: React.FC<Props> = ({
  onChange,
  padBusinessType,
}) => {
  return (
    <View style={styles.fieldContainer}>
      <View style={styles.labelContainer}>
        <Typography variant="label-md">{i18n.t('pad.pad_type')}</Typography>
      </View>
      <View style={styles.radioRow}>
        <TouchableOpacity
          onPress={() => onChange(PadBusinessType.PERSONAL)}
          style={styles.radioOption}
        >
          <RadioButton
            selected={padBusinessType === PadBusinessType.PERSONAL}
          />
          <View style={styles.radioLabel}>
            <Typography variant="paragraph-md">{i18n.t('personal')}</Typography>
          </View>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => onChange(PadBusinessType.BUSINESS)}
          style={styles.radioOption}
        >
          <RadioButton
            selected={padBusinessType === PadBusinessType.BUSINESS}
          />
          <View style={styles.radioLabel}>
            <Typography variant="paragraph-md">{i18n.t('business')}</Typography>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  fieldContainer: {
    marginBottom: 16,
  },
  labelContainer: {
    marginBottom: 8,
  },
  radioLabel: {
    marginLeft: 12,
  },
  radioOption: {
    alignItems: 'center',
    flexDirection: 'row',
    marginRight: 32,
  },
  radioRow: {
    flexDirection: 'row',
  },
});
